import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your pages
import Home from "./pages/Home";
import Login from "./pages/LoginPage"; // ✅ Corrected import
import Dashboard from "./pages/Dashboard"; // Make sure this file exists

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Homepage */}
        <Route path="/" element={<Home />} />

        {/* Login Page */}
        <Route path="/login" element={<Login />} />

        {/* Dashboard (can be protected later) */}
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;

